// Typelizer digest ad02634458dcaa8087e00b1a1ca3cdb6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /admin/productions/:production_id/characters/:character_id/voice/auditions */
  create: (
    params: { productionId: string | number; characterId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions/:production_id/characters/:character_id/voice/auditions', params, options),
    method: 'post',
  }),

  /** GET /admin/productions/:production_id/characters/:character_id/voice */
  show: (
    params: { productionId: string | number; characterId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:production_id/characters/:character_id/voice', params, options),
    method: 'get',
  }),
}
